import { ListService } from './list';
import { Site, SLD, getSldSuffixName } from './site';
import { config } from './config';
/* 简单版本 */
export function parse(query) {
    const array = [];
    return Object.keys(query).reduce((array, key) => {
        const value = query[key];
        array.push(`${key}=${value}`);
        return array;
    }, array).join('&');
}
export class UserCenterService {
    /**
     * 构建登录链接
     * @param appendRedirect 是否需要追加 redirect_uri
     * @param query query 参数
     * @returns 登录链接
     */
    static createLoginHref(appendRedirect = true, query = {}) {
        /* 构造 account 地址 */
        const account = new Site({ sld: SLD.ACCOUNT });
        let params = {
            ...query,
            client_id: config.clientId,
            from: config.clientName,
        };
        if (appendRedirect) {
            params.redirect_uri = encodeURIComponent(window.location.href);
        }
        const href = `${account.href}?${parse(params)}`;
        return href;
    }
    /**
     * 构建登出链接
     * @param appendRedirect 是否需要追加 redirect_uri
     * @param query query 参数
     * @returns 登出链接
     */
    static createLogoutHref(appendRedirect = true, query = {}) {
        /* 构造 passport 地址 */
        const { href } = new Site({ sld: SLD.PASSPORT, pathname: 'logout' });
        /* 拼装 account 登录页面 url：参考：https://confluence.zhihuiya.com/pages/viewpage.action?pageId=108873768 */
        const redirect = UserCenterService.createLoginHref(appendRedirect, query);
        return `${href}?from=${config.clientName}&redirect_uri=${encodeURIComponent(redirect)}`;
    }
    constructor() {
        this.beforeRenderMenuItems = _ => _;
        this.restrictedAccessMenuItems = [];
        this.beforeLogoutHandlers = new Set();
        this.beforeSwitchTenantHandlers = new Set();
        this.logged = false;
        this._userid = '';
        this._username = '';
        this._avatar = '';
        this._avatarColor = '';
        this._tenantName = '';
        this._companyId = '';
        this._mobileNumber = '';
        this.logoutHandler = () => {
            this.logout();
        };
    }
    get items() {
        const self = this;
        const items = [
            { key: 'account', icon: 'SolidProfile', i18n: 'PtUserCenter.account', href: new Site({ sld: SLD.ACCOUNT, pathname: 'user-settings' }).href },
            { key: 'settings', icon: 'SolidSettings', i18n: 'PtUserCenter.adminSettings', href: new Site({ sld: SLD.ADMIN }).href },
            { key: 'timer', icon: 'TimerS', i18n: 'PtUserCenter.projectTimer', href: new Site({ sld: SLD.ACCOUNT, pathname: 'user-settings/#/user/case_time' }).href },
            { key: 'team', icon: 'SolidUsers', i18n: 'PtUserCenter.team', href: self._adminConsole ? new Site({ sld: SLD.ADMIN, pathname: '#/team_group' }).href : new Site({ sld: SLD.ACCOUNT, pathname: 'user-settings/#/user/team_group' }).href },
            ...this.restrictedAccessMenuItems,
            'slot:language',
            null,
            {
                key: 'logout',
                icon: 'SolidLogout',
                i18n: 'PtUserCenter.logout',
                classname: 'patsnap-biz-user_center_menu__logout',
                $listeners: {
                    async click() {
                        const params = [
                            () => self.logout(),
                            self.logoutHref,
                            {
                                createLoginHref: UserCenterService.createLoginHref,
                                createLogoutHref: UserCenterService.createLogoutHref,
                            }
                        ];
                        await Promise.all(Array.from(self.beforeLogoutHandlers).map(h => h(...params)));
                        self.logoutHandler && self.logoutHandler(...params);
                    }
                }
            }
        ]
            /* {sld}-siemens.patsnap.eu 下移除 team 菜单项目  */
            .filter(item => {
            // @ts-ignore
            if (getSldSuffixName() === 'siemens' && item && item.key === 'team') {
                return false;
            }
            return true;
        })
            .map(item => ListService.normalize(item));
        return this.beforeRenderMenuItems(items);
    }
    set name(value) {
        this._username = value;
    }
    get name() {
        return this._username;
    }
    get uid() {
        return this._userid;
    }
    set avatar(value) {
        this._avatar = value;
    }
    get avatar() {
        return this._avatar;
    }
    get avatarColor() {
        return this._avatarColor;
    }
    get TenantName() {
        return this._tenantName;
    }
    get mobileNumber() {
        return this._mobileNumber;
    }
    get IsEnterpriseUser() {
        return !!this._companyId;
    }
    /**
     * 登出 URL
     */
    get logoutHref() {
        return UserCenterService.createLogoutHref();
    }
    /**
     * 登录 URL
     */
    get loginHref() {
        return UserCenterService.createLoginHref();
    }
    setUserInfo(user) {
        if (user) {
            this._userid = user.id;
            this._username = user.name;
            this._avatarColor = user.avatarColor;
            this.avatar = user.avatar;
            this._adminConsole = user.adminConsole;
            this._tenantName = user.tenantName;
            this._companyId = user.companyId;
            this._mobileNumber = user.mobileNumber;
        }
        else {
            this._userid = '';
            this._username = '';
            this._avatar = '';
            this._avatarColor = '';
            this._tenantName = '';
            this._companyId = '';
            this._mobileNumber = '';
        }
    }
    login(user) {
        if (typeof user === 'string') {
            this._username = user;
            this.avatar = '';
        }
        else {
            this.setUserInfo(user);
        }
        this.logged = true;
    }
    logout() {
        this.logged = false;
        this.setUserInfo();
        window.location.href = this.logoutHref;
    }
}
//# sourceMappingURL=user-center.js.map